module.exports = __webpack_public_path__ + "static/wall_12-7dbfcf548dddccb3b862a8f8ea29f763.jpg";